import Player from '@vimeo/player';

const videoPlay = document.querySelector('.js-inline-video-play');

let player, video, posterFrame;

export function init () {   
    if (videoPlay) {
        video = videoPlay.closest('.js-cover-video').querySelector('iframe');
        posterFrame = document.querySelector('.js-cover-poster-frame');

        //  Add unique ID to the video element and ensure the src has the enable api query string parameter
        video.id = 'inline-video-cover';

        if (videoPlay.dataset.source == 'vimeo') {
            // Vimeo
            if (video.src.includes('?')) {
                video.src = video.src + '&enablejsapi=1';
            } else {
                video.src = video.src + '?enablejsapi=1';
            }

            // Build Vimeo player
            player = new Player(video);

            player.ready().then(playerReady());
        } else {
            // YouTube
            if (video.src.includes('?')) {
                video.src = video.src + '&enablejsapi=1';
            } else {
                video.src = video.src + '?enablejsapi=1';
            }
            
            // Build YouTube player
            player = new YT.Player(video, {
                events: {
                    'onReady': playerReady,
                    'onStateChange': function (event) {
                        if (event.data == YT.PlayerState.PAUSED) {
                            // Update localstorage value
                            localStorage.setItem(window.location, player.getCurrentTime());
                        }
                    }
                }
            });
        }

        // Attach click event to this play trigger
        videoPlay.addEventListener('click', playVideo.bind(player));
    }
}

function playVideo() {
    // Fade out play controls and poster image
    posterFrame.classList.add('opacity-0', 'pointer-events-none');
    posterFrame.closest('picture').classList.add('pointer-events-none');
    videoPlay.classList.add('opacity-0', 'pointer-events-none');

    // Play video once poster frame has hidden
    setTimeout(() => {
        posterFrame.style.display = 'none';

        if (videoPlay.dataset.source == 'vimeo') {
            player.play();
        } else {
            player.playVideo();
        }
    }, 300);
}

function playerReady(e) {
    // Check localstorage and load in saved time if available
    const savedTime = localStorage.getItem(window.location);
    
    if (savedTime) {
        if (videoPlay.dataset.source == 'vimeo') {
            player.setCurrentTime(savedTime);
        } else {
            player.seekTo(savedTime, true);

            // Must issue pause command to prevent autoplaying video immediately after seekTo
            player.pauseVideo();
        }
    }

    videoPlay.classList.add('flex');
    videoPlay.classList.remove('hidden');
}
